import app from 'flarum/forum/app';
export default function materialUrl(post) {
  const discussion = post.discussion();

  // Штатный генератор Flarum учитывает slug и номер сообщения. Абсолютный URL нужен форме жалобы,
  // чтобы сервер однозначно нашёл конкретный материал даже при переходе с другой страницы.
  const relativeUrl = app.route.discussion(discussion, post.number());
  return new URL(relativeUrl, app.forum.attribute('baseUrl')).toString();
}
flarum.reg.add('devconnect-content-complaints', 'forum/service/materialUrl', materialUrl);